module.exports = __webpack_public_path__ + "static/media/img_contest_main.33fa4ffa.jpg";